"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refetchUsers = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var _UsersManager = _interopRequireDefault(require("composer-lib/data/UsersManager"));

var usersManager = new _UsersManager.default();
var fetchUsersSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_USERS_SUCCEEDED);
var fetchUsersFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_USERS_FAILED);

var refetchUsers = function refetchUsers() {
  return function (dispatch) {
    usersManager.fetch().then(function (resp) {
      return dispatch(fetchUsersSucceeded(resp));
    }, function (resp) {
      return dispatch(fetchUsersFailed(resp));
    });
  };
};

exports.refetchUsers = refetchUsers;